import React from 'react';
//material
import {Card, CardContent, withStyles, CardHeader, CardMedia, CardActionArea} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './my-next-meeting-widget-styles';
//lib
import Moment from 'moment';
import { withRouter } from 'react-router-dom';

const MyNextMeetingWidgetView = (props) => {
  const {classes, isLoading, myMeetings, history} = props;
  const nextMeeting = myMeetings.length ? myMeetings[0] : null;

  const navigate = () =>
    history.push('/meeting/' + nextMeeting.eventId);

  return (
    <Card className={classes.card}>
      <CardActionArea className={classes.actionArea} onClick={nextMeeting ? navigate : null} disabled={!nextMeeting}>
        {
          isLoading ?
            <Skeleton width={'50%'} className={classes.titleSkeleton}/> :
            <CardHeader title={'My Next Meeting'} classes={{title: classes.title}} className={classes.titleContainer}/>
        }

        {
          !isLoading && nextMeeting !== null &&
          <>
            <CardMedia
              title={'Meeting Image'}
              className={classes.image}
              image={nextMeeting.imageUrl}/>

            <CardContent className={classes.cardContent}>
              <div className={classes.name}>
                {nextMeeting.eventName}
              </div>

              <div className={classes.subtitle}>
                {Moment(new Date(nextMeeting.eventDate)).format('Do MMMM YYYY')}
              </div>

              <div className={classes.subtitle}>
                {nextMeeting.clubName}
              </div>
            </CardContent>
          </>
        }

        {
          !isLoading && nextMeeting === null &&
            <CardContent className={classes.cardContent}>
              <div className={classes.noNextMeeting}>
                No Next Meeting
              </div>
            </CardContent>
        }

        {
          isLoading &&
            <>
              <Skeleton variant={'rect'} height={165} className={classes.imageSkeleton} />
              <div className={classes.textSkeleton}>
                <Skeleton height={24}/>
                <Skeleton height={12} width={'40%'} />
                <Skeleton height={12} width={'40%'} />
              </div>
            </>
        }
      </CardActionArea>
    </Card>
  );
};

export default withRouter(withStyles(styles) (MyNextMeetingWidgetView));
